import styled from "@emotion/styled";
import { Header } from "react-aria-components";

export const StyledSelectionHeader = styled(Header)`
  font-size: ${({ theme }) => theme.fontSizes.xsmall};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  line-height: ${({ theme }) => theme.lineHeights.xsmall};
  padding: ${({ theme }) => theme.spacing.sm};
  background-color: ${({ theme }) => theme.colors.surface.menu};
  color: ${({ theme }) => theme.colors.text.secondary};
`;
